var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Information = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M10 1.6C14.65 1.6 18.4 5.4 18.4 10C18.4 14.6 14.65 18.4 10 18.4C5.35 18.4 1.6 14.65 1.6 10C1.6 5.35 5.35 1.6 10 1.6ZM10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0Z" }),
    React.createElement("path", { fill: "currentColor", d: "M8.9 15.05H11V8.20002H8.9V15.05Z" }),
    React.createElement("path", { fill: "currentColor", d: "M9.95 7C10.55 7 11 6.55 11 5.95C11 5.35 10.55 4.9 9.95 4.9C9.35 4.9 8.9 5.35 8.9 5.95C8.9 6.55 9.35 7 9.95 7Z" }))); });
//# sourceMappingURL=Information.js.map